import { render } from "./BrowserWarning.vue?vue&type=template&id=739f898c&scoped=true"
import script from "./BrowserWarning.vue?vue&type=script&lang=js"
export * from "./BrowserWarning.vue?vue&type=script&lang=js"

import "./BrowserWarning.vue?vue&type=style&index=0&id=739f898c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-739f898c"]])

export default __exports__